export default "__VITE_ASSET__GzOaSJCd__"